import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AISearchResultItem, AQASearchResult } from '../../models';

@Component({
  selector: 'app-aqa-search-result-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './aqa-search-result-card.component.html',
  styleUrl: './aqa-search-result-card.component.scss'
})
export class AqaSearchResultCardComponent implements OnDestroy {
  @Input() item!: AQASearchResult;
  @Input() showSender: boolean = false;
  @Output() viewClick = new EventEmitter();

  thumbnailBlobUrl: string = '';
  thumbnailLoading: boolean = false;
  thumbnailError: boolean = false;

  private aiSearchBaseUrl: string = '';

  constructor(
    @Inject('CONFIG_SETTINGS') private config: any,
    @Inject(OKTA_AUTH) private auth: OktaAuth,
    private http: HttpClient
  ) {
    const configSettings = this.config['general'];
    if (configSettings?.aiSearchApiUrl) {
      const searchUrl = configSettings['aiSearchApiUrl'] as string;
      this.aiSearchBaseUrl = searchUrl.replace(/\/search\/?$/, '');
    }
  }

  ngOnDestroy(): void {
    if (this.thumbnailBlobUrl) {
      URL.revokeObjectURL(this.thumbnailBlobUrl);
    }
  }

  get displayDescription(): string {
    if (this.item.subjectHighlights && this.item.subjectHighlights?.length > 0) {
      return this.item.subjectHighlights[0];
    }
    if (this.item.contentHighlights && this.item.contentHighlights?.length > 0) {
      return this.item.contentHighlights[0];
    }
    if (this.item.attachmentHighlights && this.item.attachmentHighlights?.length > 0) {
      return this.item.attachmentHighlights[0];
    }
    return this.item.document.content || '';
  }

  get displayTitle(): string {
    if (this.item.subjectHighlights && this.item.subjectHighlights?.length > 0) {
      return this.item.subjectHighlights[0];
    }

    if (this.item.document.subject && this.item.document.subject.length > 0) {
      return this.item.document.subject;
    }

    if (this.item.document.metadata_subject && this.item.document.metadata_subject.length > 0) {
      return this.item.document.metadata_subject;
    }

    if (this.item.document.normalizedSubject && this.item.document.normalizedSubject.length > 0) {
      return this.item.document.normalizedSubject;
    }

    return 'Untitled';
  }

  getSender(): string {
    return this.item.document.metadata_message_from ?? "";
  }

  get formattedPublishedDate(): string {
    if (this.item.document.creationDate) {
      const date = new Date(this.item.document.creationDate);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
    if (this.item.document.metadata_creation_date) {
      const date = new Date(this.item.document.metadata_creation_date);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
    return '';
  }

  onTitleClick(event: Event): void {
    event.preventDefault();

    this.viewClick.emit();
    return;
  }
}
